import { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import {
  Card,
  CardTitle,
  CardText,
  Button,
  Container,
  Spinner,
} from "reactstrap";

import pageService from "../../service/page.service";
import LogoutIcon from "../../components/LogoutIcon/Logout";

const Dashboard = () => {
  const [pages, setPages] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    pageService.getPages().then((response) => {
      setPages(response.data);
      setLoading(false);
    }).catch((err) => console.log(err))
  }, []);

  const handleDelete = async (e) => {
    const admin = JSON.parse(localStorage.getItem("admin"));
    let id = e.target.id;

    await pageService.deletePage({ admin, id });

    const data = await pageService.getPages();
    setPages(data.data);
  };

  return (
    <>
      <LogoutIcon />
      <Helmet>
        <style>{"body { background-color: lightgray; }"}</style>
      </Helmet>
      <Container>
        {loading && (
          <div data-testid='loading' className="centerr">
            <Spinner>.</Spinner>
          </div>
        )}
        {pages.map((page) => (
          <div key={page.id} data-testid='pages-card'>
            <Card id={page.id} body className="text-center">
              <Link
                style={{ textDecoration: "none", color: "#08507e" }}
                to={`/editar-pagina/${page.id}`}
              >
                <CardTitle tag="h5">{page.title}</CardTitle>
                <CardText>{page.description}</CardText>
                <Button style={{ width: "200px" }}>Editar</Button>
              </Link>
              <div className="center">
                <Button
                  style={{ width: "200px" }}
                  id={page.id}
                  onClick={handleDelete}
                  className="mt-3"
                  color="danger"
                >
                  Excluir
                </Button>
              </div>
            </Card>
          </div>
        ))}

        <Card body className="centerr">
          <Link
            className="centerr"
            style={{ textDecoration: "none", color: "white", width: "100%" }}
            to="/nova-pagina"
          >
            <Button style={{ width: "200px" }} color="success">
              Criar Página
            </Button>
          </Link>
        </Card>
      </Container>
    </>
  );
};

export default Dashboard;
